/**
 * WebSocket scope keys (subset of ann-web-app `src/utils/enums.js` WebSocketScope).
 * Used by chat streaming subscription key `scope:CONVERSATION`.
 */
export const WebSocketScope = {
  CONVERSATION: 'CONVERSATION',
};
